import React from 'react';

export const PREMIUM_INTRO_CALL_URL = 'https://calendly.com/carl-complimind/30min';

interface PremiumUpsellCTAProps {
  className?: string;
  text?: string;
  showTail?: boolean;
}

export default function PremiumUpsellCTA({
  className,
  text = 'Click here to book an introduction call to CompliMind',
  showTail = true
}: PremiumUpsellCTAProps) {
  return (
    <a
      href={PREMIUM_INTRO_CALL_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`relative bg-gradient-to-br from-blue-500 to-blue-600 text-white 
                   px-5 py-3 rounded-2xl shadow-lg
                   transition-all duration-200
                   cursor-pointer
                   min-w-[200px] text-center mb-2 ${className || ''}`}
      style={{
        filter: 'drop-shadow(0 4px 6px rgba(59, 130, 246, 0.3))'
      }}
    >
      <span className="font-medium text-sm leading-snug block">
        {text.split('\n').map((line, index, array) => (
          <React.Fragment key={index}>
            {line}
            {index < array.length - 1 && <br />}
          </React.Fragment>
        ))}
      </span>
      {/* Speech bubble tail */}
      {showTail && (
        <span
          className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0"
          style={{
            borderLeft: '10px solid transparent',
            borderRight: '10px solid transparent',
            borderTop: '10px solid #2563eb'
          }}
        />
      )}
    </a>
  );
}
